import { Component, OnInit } from '@angular/core';
import { SummarySectionBaseComponent } from '../summary-section-base.component';
import { DIVIDER_STYLE_HELPER } from '../../../../../builders/form-builder/controls/divider/divider-editor/divider-editor.component';
import { FormSummaryService } from './form-summary.service';
import { IFormPart } from './form-summary.model';
import * as _ from 'lodash';
import { FormBuilderControlTypes } from '../../../../../builders/form-builder/form-builder-control.types';
import { RATING_TYPES } from 'src/app/shared/components/ey-rating/ey-display-rating/ey-display-rating.component';
import { RATING_SELECTION_VALUES } from 'src/app/designer/builders/form-builder/controls/rating/rating-editor/rating-editor.component';

@Component({
  selector: 'app-form-summary',
  templateUrl: './form-summary.component.html',
  styleUrls: ['./form-summary.component.scss'],
})
export class FormSummaryComponent extends SummarySectionBaseComponent implements OnInit {
  formParts: IFormPart[];
  controlType = FormBuilderControlTypes;
  constructor(private formSummaryService: FormSummaryService) {
    super();
  }

  ngOnInit(): void {
    this.formParts = this.formSummaryService.mapFormPartsToView(_.cloneDeep(this.page.moduleFlowPage.properties));
  }

  getHrStyle(type: string): any {
    return DIVIDER_STYLE_HELPER[type];
  }

  get isHidden(): boolean {
    return this.page.moduleFlowPage?.isHidden;
  }

  getPropertyVisibility(property: any): boolean {
    if (property.isCriteriaSet) {
      return property.isCriteriaSatisfied;
    }
    return true;
  }

  ratingType(ratingType: string): RATING_TYPES {
    return RATING_TYPES[RATING_SELECTION_VALUES.find((x) => x.value == ratingType)?.name];
  }
}
